import axios from "axios";
import { SNAPSHOT, snapshotAdapter } from "./snapshot";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const TOKEN_KEY = "ciarb_admin_token";
export const GATE_KEY = "ciarb_gate_token";
export const GATE_EVENT = "ciarb:gate-required";

export const api = axios.create({ baseURL: API, ...(SNAPSHOT ? { adapter: snapshotAdapter } : {}) });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const gate = localStorage.getItem(GATE_KEY);
  if (gate) config.headers["X-Site-Gate-Token"] = gate;
  return config;
});
// Gate token missing/revoked: drop it and let SiteProvider show the gate page.
api.interceptors.response.use(undefined, (e) => {
  if (e?.response?.status === 401 && e.response.data?.gate_required) {
    localStorage.removeItem(GATE_KEY);
    window.dispatchEvent(new Event(GATE_EVENT));
  }
  return Promise.reject(e);
});
export const isGateError = (e) => e?.response?.status === 401 && Boolean(e.response.data?.gate_required);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Not saved: " + detail.map((d) => (d && typeof d.msg === "string" ? `${String(d.loc?.slice(-1)[0] ?? "value").replace(/_/g, " ")}: ${d.msg.replace(/^String should/, "should")}` : "invalid value")).join("; ");
  return detail.msg || String(detail);
}

export const mediaSrc = (url) => {
  if (!url || !url.startsWith("/api/")) return url;
  const gate = url.startsWith("/api/media/") && localStorage.getItem(GATE_KEY);
  return `${BACKEND}${url}${gate ? `${url.includes("?") ? "&" : "?"}gate_token=${encodeURIComponent(gate)}` : ""}`;
};

export const newKey = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
